import type { ActionHandler } from '../types'

export const handleAdjustFunds: ActionHandler<'ADJUST_FUNDS'> = async (ctx, payload) => {
  const { data: char } = await ctx.supabase
    .from('characters')
    .select('funds_denarii')
    .eq('id', ctx.characterId)
    .single()

  if (!char) throw new Error('Character not found')

  const oldVal = char.funds_denarii
  const newVal = Math.max(0, oldVal + payload.delta)

  const { error } = await ctx.supabase
    .from('characters')
    .update({ funds_denarii: newVal })
    .eq('id', ctx.characterId)

  if (error) throw error

  return {
    effects: [{
      character_id: ctx.characterId,
      target_table: 'characters',
      target_row_id: ctx.characterId,
      target_field: 'funds_denarii',
      operation: 'UPDATE' as const,
      old_value: oldVal,
      new_value: newVal,
    }],
    label: payload.delta >= 0
      ? `+${payload.delta}d funds${payload.reason ? ` (${payload.reason})` : ''}`
      : `${payload.delta}d funds${payload.reason ? ` (${payload.reason})` : ''}`,
  }
}
